import { Customization } from '@eduvision/toolkit';

export const ImprintView: Customization['ImprintView'] = {
	externalLink: 'https://www.charta-der-vielfalt.de/impressum',
};
